import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, CustomPageConfigService, Customer, CustomerService, HomeComponent, HomeNavigationConfigService } from 'gung-standard';
import { forkJoin, Observable, of } from 'rxjs';
import { first, mergeMap } from 'rxjs';

@Component({
  selector: 'tylo-tylo-home',
  templateUrl: './tylo-home.component.html',
  styleUrls: ['./tylo-home.component.css']
})
export class TyloHomeComponent extends HomeComponent implements OnInit {
  constructor(
    protected router: Router,
    protected authService: AuthService,
    protected customerService: CustomerService,
    homeNavigationConfigService: HomeNavigationConfigService,
    protected customPageConfigService: CustomPageConfigService
  ) {
    super(router, authService, customerService, homeNavigationConfigService, customPageConfigService);
  }

  ngOnInit(): void {
    this.authService
      .getCurrentUser()
      .pipe(
        first(),
        mergeMap(user => {
          const requests: Observable<any>[] = [of(user)];
          // get customers only for users
          if (!(user.roles.includes('SALES') || user.roles.includes('ADMIN')) && user.roles.includes('USER')) {
            requests.push(this.customerService.getCustomers().pipe(first()));
          }
          return forkJoin(requests);
        })
      )
      .subscribe(([user, customers]) => {
        if (user.roles.includes('DIGITALASSETS')) {
          this.router.navigate(['/digital-assets']);
        } else if (user.roles.includes('SALES') || user.roles.includes('ADMIN')) {
          this.router.navigate(['/sales-dashboard']);
        } else if (user.roles.includes('USER')) {
          if (customers && (customers as Customer[]).length > 1) {
            this.router.navigate(['/delivery-location']);
          } else {
            this.router.navigate(['/categories']);
          }
        } else if (user.roles.includes('ANONYMOUS')) {
          this.router.navigate(['/products']);
        }
      });
  }
}
